export default __webpack_public_path__ + "static/media/younger.012c22b1.svg";